export enum AnalyticsReportCreationSource {
  AskRedo = "ask_redo",
  Mcp = "mcp",
  Admin = "admin",
}
